export const ApplicationsConst = {
  INTERNAL_COMMENT_MAX_LENGTH: 300,
  MESSAGE_MAX_LENGTH: 300,
};
